import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["link"];

  connect() {
    this.sections = this.linkTargets
      .map((link) => document.getElementById(link.dataset.sectionId))
      .filter(Boolean);

    this.observer = new IntersectionObserver(
      (entries) => this.updateActiveFromEntries(entries),
      {
        root: null,
        rootMargin: "-15% 0px -65% 0px",
        threshold: [0, 0.1, 0.25],
      }
    );

    this.sections.forEach((section) => this.observer.observe(section));

    const hashId = window.location.hash.replace("#", "");
    if (hashId && this.linkTargets.some((link) => link.dataset.sectionId === hashId)) {
      this.setActive(hashId);
    } else if (this.linkTargets.length) {
      this.setActive(this.linkTargets[0].dataset.sectionId);
    }

    this.linkTargets.forEach((link) => {
      link.addEventListener("click", () => {
        this.setActive(link.dataset.sectionId);
      });
    });
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  updateActiveFromEntries(entries) {
    const visible = entries
      .filter((entry) => entry.isIntersecting)
      .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

    if (visible.length > 0) {
      this.setActive(visible[0].target.id);
    }
  }

  setActive(sectionId) {
    this.linkTargets.forEach((link) => {
      const isActive = link.dataset.sectionId === sectionId;
      link.classList.toggle("is-active", isActive);
      if (isActive) {
        link.setAttribute("aria-current", "location");
      } else {
        link.removeAttribute("aria-current");
      }
    });
  }
}
